import { Colors } from "@flatfile/design-system";
import { Border } from "../Borders.js";
import { FlexCenter } from "../Flex.js";
import styled from "styled-components";
const BooleanInput = styled.div`
  ${FlexCenter};
  gap: 1em;
  font-size: 0.85em;
  font-weight: 600;

  ${(props) => props.disabled && `
    input {
      opacity: 70%;
    }
  `}

  input {
    appearance: none;
    background-color: ${Colors.White};
    margin: 0;
    font: inherit;
    width: 16px;
    height: 16px;
    transition: 80ms all ease-in-out;

    &:active {
      opacity: 70%;
    }
  }
`;
const RadioInput = styled(BooleanInput)`
  &,
  input,
  label {
    cursor: pointer;
  }

  input[type='radio'] {
    border-radius: ${(props) => props.theme.inputs.radio.borderRadius};
    color: ${(props) => props.theme.inputs.radio.color};
    border: ${(props) => Border.small({ color: props.theme.inputs.radio.borderColor })};

    &:checked {
      background-color: ${(props) => props.theme.inputs.radio.color};
      border: ${(props) => Border.small({ color: props.theme.inputs.radio.color })};
    }

    &:checked:before {
      position: absolute;
      content: '';
      border-radius: ${(props) => props.theme.inputs.radio.borderRadius};
      border: 2px solid ${Colors.White};
      width: 10px;
      height: 10px;
    }
  }
`;
styled.label`
  font-weight: 400;
  font-size: 0.75rem;
`;
styled.div`
  background: ${Colors.Pigeon600};
  height: 2px;
  width: 8px;
  position: absolute;
  border-radius: ${(props) => props.theme.icon.borderRadius};
  margin-left: 4px;
  align-self: center;
  justify-self: center;
`;
export {
  RadioInput
};
